import { createSvgIcon } from "@mui/material";

export const PlacementRightIcon = createSvgIcon(
  <svg viewBox="0 0 12 9" fill="none">
    <path
      fill="currentColor"
      d="M11.811.844a.85.85 0 0 1-.844.844H5.905a.833.833 0 0 1-.844-.844A.85.85 0 0 1 5.905 0h5.062c.449 0 .844.396.844.844m.002 3.375a.85.85 0 0 1-.844.843H.844A.833.833 0 0 1 0 4.22a.85.85 0 0 1 .844-.844h10.125c.448 0 .844.396.844.844m-.002 3.375a.85.85 0 0 1-.844.843H5.905a.833.833 0 0 1-.844-.843.85.85 0 0 1 .844-.844h5.062c.449 0 .844.396.844.844"
    />
  </svg>,
  "PlacementRightIcon",
);
